module.exports = __webpack_public_path__ + "school/img/catalog.6a7f8e50.jpg";